import { useEffect, useRef, useState } from 'react'
import { Card, CardBody, CardHeader, FormSection, Icon, LoadingState, ScrollBar, StackList, StackListItem } from 'admination-react'
import { faelligText, listAufgaben, nachFaelligkeit, zustaendigText, type TeilnahmeAufgabe } from '@/core/data/aufgaben'
import { friendlyErrorMessage } from '@/core/lib/dbError'
import { useApp } from '@/core/state/appStore'
import { ModalHeader } from '../ModalHeader'

function AufgabeKarte({ aufgabe }: { aufgabe: TeilnahmeAufgabe }) {
  const { dispatch } = useApp()
  const oeffnen = () => dispatch({ type: 'CHANGE_PHASE', target: { modal: 'aufgabe', tab: 'form', aufgabeId: aufgabe.id, document: { name: aufgabe.name, id: aufgabe.dokument_id } }, remember: true })
  return <Card className={aufgabe.erledigt_am === null ? undefined : 'is-disabled'} onClick={aufgabe.formular ? oeffnen : undefined}>
    <CardHeader>{aufgabe.name}</CardHeader>
    <CardBody>
      <span><Icon name="i-calendar" />{faelligText(aufgabe)}</span>
      <span><Icon name="i-person" />{zustaendigText(aufgabe)}</span>
    </CardBody>
  </Card>
}

export function AktivierungAufgaben({ coachingId }: { coachingId: string }) {
  const scrollerRef = useRef<HTMLElement>(null)
  const [aufgaben, setAufgaben] = useState<TeilnahmeAufgabe[] | null>(null)
  const [fehler, setFehler] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    listAufgaben(coachingId).then(
      (rows) => { if (!cancelled) setAufgaben(rows) },
      (error: unknown) => { if (!cancelled) setFehler(friendlyErrorMessage(error, "Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.")) },
    )
    return () => { cancelled = true }
  }, [coachingId])

  return <>
    <ModalHeader />
    <main className="form" data-scroll-host ref={scrollerRef}>
      {!aufgaben && !fehler ? <LoadingState>Aufgaben werden geladen …</LoadingState>
        : <div className="form-column">
          {aufgaben
            ? <StackList className="stack-list--cards" aria-label="Aufgaben">
              {[...aufgaben].sort(nachFaelligkeit).map((aufgabe) => <StackListItem key={aufgabe.id}><AufgabeKarte aufgabe={aufgabe} /></StackListItem>)}
            </StackList>
            : <FormSection label="Aufgaben konnten nicht geladen werden">
              <p role="alert">{fehler}</p>
            </FormSection>}
        </div>}
    </main>
    <ScrollBar scrollerRef={scrollerRef} />
  </>
}
